import { render, staticRenderFns } from "./FormOptionGroup.vue?vue&type=template&id=0850e6b9&"
import script from "./FormOptionGroup.vue?vue&type=script&lang=js&"
export * from "./FormOptionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports